// Wrapper that allows react-lazyload to work even when mounted at the same time as the scrollContainer
import React from 'react';
import { default as ReactLazyLoad, LazyLoadProps } from 'react-lazyload';

import { useRerender } from '@hcs/hooks';

export const LazyRender = (props: LazyLoadProps) => {
  const { scrollContainer } = props;
  const elm =
    typeof scrollContainer === 'string'
      ? document.querySelector(scrollContainer)
      : scrollContainer;
  useRerender({ deps: [elm], shouldRerender: !elm, max: 1 });
  if (!elm) {
    return null;
  } else {
    return <ReactLazyLoad {...props} />;
  }
};
